export default __webpack_public_path__ + "static/media/member-onboarding-shapes.412afd1a.svg";